import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { PATHS } from '../../../../constants/routes';

const CHECKOUT_RETURN_MARKER_KEY = 'checkout_popup_return_marker_v1';
const ACCOUNT_ORDERS_PATH = `${PATHS.account}/orders`;

const CheckoutSuccessPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        const paymentId = searchParams.get('payment_id') || searchParams.get('paymentId') || sessionStorage.getItem('yoo_payment_id') || '';
        const orderNumber = searchParams.get('orderNumber') || sessionStorage.getItem('yoo_order_num') || '';
        const normalizedPaymentId = String(paymentId || '').trim();
        const normalizedOrderNumber = String(orderNumber || '').trim();
        try {
            if (normalizedPaymentId) {
                sessionStorage.setItem(
                    CHECKOUT_RETURN_MARKER_KEY,
                    JSON.stringify({
                        paymentId: normalizedPaymentId,
                        orderNumber: normalizedOrderNumber,
                        createdAt: Date.now(),
                    }),
                );
            } else {
                sessionStorage.removeItem(CHECKOUT_RETURN_MARKER_KEY);
            }
        } catch {
            // ignore
        }
        navigate(ACCOUNT_ORDERS_PATH, { replace: true });
    }, [navigate, searchParams]);
    return null;
};

export default CheckoutSuccessPage;
